import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_AUTOMATION_DOS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 60,
    type: 'action',
    actions: [
      {
        name: 'expand',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'doS',
    label: 'DoS',
    width: 100,
    type: 'date',
  },
  // {
  //   dataKey: 'treatmentDetails',
  //   label: 'Treatment Details',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'amountDue',
    label: 'Amount Due',
    width: 150,
    type: 'currency',
    alignClass: 'text-end',
  },
  {
    dataKey: 'arAge',
    label: 'A/R Age',
    width: 150,
    type: 'number',
    alignClass: 'text-end',
  },
  {
    dataKey: 'arBucket',
    label: 'A/R Bucket',
    width: 150,
    type: 'text',
    alignClass: 'text-center',
  },
];

export const TABLE_CONFIG_COLUMNS_AUTOMATION_PATIENT: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 100,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'patientId',
    label: 'Patient ID',
    width: 150,
    type: 'number',
  },
  { dataKey: 'patientName', label: 'Patient Name', width: 100, type: 'text' },
  {
    dataKey: 'provider',
    label: 'Provider',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amountDue',
    label: 'Amount Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'currentBalance',
    label: '0-30 days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'thirtyDay',
    label: '31-60 days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'sixtyDay',
    label: '61-90 days',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'ninetyDay',
    label: '90+ days',
    width: 150,
    type: 'currency',
  },
];

export const TABLE_CONFIG_COLUMNS_AUTOMATION_PAYOR: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 150,
    type: 'action',
    actions: [
      {
        name: 'view',
        iconName: 'view',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'payorId',
    label: 'Payor ID',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'payor',
    label: 'Payor',
    width: 300,
    type: 'text',
  },
  {
    dataKey: 'amountDue',
    label: 'Total Due Amount',
    width: 200,
    type: 'currency',
  },
];

export const TABLE_CONFIG_COLUMNS_AUTOMATION_PAYOR_DETAILS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 100,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'patientId',
    label: 'Patient ID',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'subscriberId',
    label: 'Subscriber ID',
    width: 150,
    type: 'number',
  },
  { dataKey: 'patientName', label: 'Patient Name', width: 150, type: 'text' },
  {
    dataKey: 'doS',
    label: 'DoS',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'insPortionEstimate',
    label: 'Ins. Portion Estimate',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'insPaidAmount',
    label: 'Ins. Paid Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'insDueAmount',
    label: 'Ins. Due Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'arAge',
    label: 'A/R Age',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'arBucket',
    label: 'A/R Bucket',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'claimSubmittedDate',
    label: 'Claim Submitted Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'claimStatus',
    label: 'Claim Status',
    width: 150,
    type: 'status',
  },
];

export const TABLE_CONFIG_COLUMNS_AUTOMATION_TARGET_LISTS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 150,
    type: 'action',
    actions: [
      {
        name: 'view',
        iconName: 'view',
      },
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'filterName',
    label: 'Filter Name',
    width: 200,
    type: 'text',
  },
  { dataKey: 'description', label: 'Description', width: 300, type: 'text' },
  {
    dataKey: 'targetedPatient',
    label: 'Targeted Patients',
    width: 100,
    type: 'link',
  },
  {
    dataKey: 'targetedAmount',
    label: 'Total Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'createdOn',
    label: 'Created On',
    width: 200,
    type: 'date',
  },
];

export const TABLE_CONFIG_COLUMNS_AUTOMATION_TARGET_LISTS_DETAILS_LIST: DyTableColumn[] =
  [
    {
      dataKey: 'patientId',
      label: 'Patient ID',
      width: 150,
      type: 'number',
    },
    {
      dataKey: 'patientName',
      label: 'Patient Name',
      width: 200,
      type: 'text',
    },
    {
      dataKey: 'doS',
      label: 'DoS',
      width: 200,
      type: 'date',
    },
    {
      dataKey: 'treatmentDetails',
      label: 'Treatment Details',
      width: 300,
      type: 'text',
    },
    {
      dataKey: 'amountDue',
      label: 'Amount Due',
      width: 150,
      type: 'currency',
    },
    {
      dataKey: 'provider',
      label: 'Provider',
      width: 200,
      type: 'text',
    },
    {
      dataKey: 'arAge',
      label: 'A/R Age',
      width: 150,
      type: 'number',
    },
    {
      dataKey: 'arBucket',
      label: 'A/R Bucket',
      width: 150,
      type: 'text',
    },
  ];
